<template>
  <v-card-text style="color: #4F4F4F">
    <v-row class="pa-3">
      Sorry, we experienced a problem communicating with FormStack. Please contact&nbsp;<a target="_blank" href="https://hawksoft.com/support">HawkSoft Support</a>.
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'Error'
};
</script>
